import { useState, useEffect } from "react";
import { Link, useHistory } from 'react-router-dom';
import api from '../api/api';
import { KioskTimeConfig } from './kioskTimeConfig';
import stringHelpers from "../../utilities/stringHelpers";
import UploadFile from "../shared/file-uploader";
import { MinutesInputWithUnit } from "../shared/minutesInputWithUnit";

export default function AddKiosk(props) {
    const [site, setSite] = useState(null);
    const [kioskName, setKioskName] = useState(null);
    const [webKioskEnabled, setWebKioskEnabled] = useState(false);
    const [kioskAppEnabled, setKioskAppEnabled] = useState(false);
    const [timeSpanRows, setTimeSpanRows] = useState([]);
    const [hideExpiryDate, setHideExpiryDate] = useState(false)
    const [logoAttachment, setLogoAttachment] = useState(null)
    const [showBlueBadgeNumber, setShowBlueBadgeNumber] = useState(false)
    const [addEntriesToClient, setAddEntriesToClient] = useState(false)
    const [maxStayMinutes, setMaxStayMinutes] = useState(null);
    const [noReturnWithinMinutes, setNoReturnWithinMinutes] = useState(null);

    const history = useHistory();

    const handleSubmit = () => {
        if (site) {
            api.addNewKiosk(
                props.organisationId, props.match.params.siteId,
                kioskName, timeSpanRows, webKioskEnabled, kioskAppEnabled, logoAttachment?.id, hideExpiryDate, showBlueBadgeNumber, addEntriesToClient, maxStayMinutes, noReturnWithinMinutes,
                () => history.push(`/organisation/${ props.organisationId }/client/${ site.clientId }/site/${ props.match.params.siteId }`),
                error => console.log(error),
                props.token
            )
        }
    }

    const updateTimeSpanRow = (id, value, mode, customLabel, startTimeDeltaMinutes, endOfDayDeltaMinutes, maximumTimeOfDay) => {

        setTimeSpanRows(timeSpanRows
            .toSpliced(
                id, 1, 
                { 
                    type: mode, 
                    duration: value, 
                    label: !stringHelpers.isNullOrEmpty(customLabel) ? customLabel : null, 
                    startTimeDeltaMinutes: startTimeDeltaMinutes, 
                    endOfDayDeltaMinutes: endOfDayDeltaMinutes,
                    maximumTimeOfDay
                }
            )
        )
    }

    const fetchSite = () => {
        api.getSite(
            data => setSite(data),
            () => { },
            props.match.params.siteId,
            props.organisationId,
            props.token
        )
    }

    useEffect(() => fetchSite(), [])

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-header">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h5 className="mb-0">Add New Kiosk</h5>
                                </div>
                            </div>
                        </div>

                        {
                            site &&
                            <div className="card-body bg-light border-top details-container">
                                <div className="row">
                                    <div className="col-md-3 col-12">
                                        <p className="font-weight-semi-bold mb-3">Kiosk Name<span className="req"></span></p>
                                    </div>
                                    <div className="col-md-6 col-12 px-0">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={ kioskName } onChange={ (e) => setKioskName(e.target.value) } />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-3 col-12">
                                        <p className="font-weight-semi-bold mb-3">Logo</p>
                                    </div>
                                    <div className="col-md-6 col-12 px-0 d-flex flex-column align-items-start mt-1 mb-3">
                                        <button className="btn btn-falcon-default my-2" data-toggle="modal" data-target="#add-logo-attachment">Select Logo</button>
                                        
                                        {logoAttachment && 
                                            <div className='position-relative'>
                                                <button data-toggle="modal" data-target="#clear-logo-attachment" className='btn p-0 bg-white rounded-circle image-clear'><i className='far fa-times-circle fs-1'></i></button>
                                                <img className='rounded border p-1 mb-1' width={200} src={logoAttachment.url} />
                                                <p className='m-0'>{logoAttachment?.filename}</p>
                                            </div>
                                        }
                                    </div>
                                    <div className="modal fade save-dialog success-dialog" id="add-logo-attachment" tabIndex="-1" role="dialog">
                                        <UploadFile onSuccess={(file) => setLogoAttachment(file)} type="Logo" organisationId={props.organisationId} />
                                    </div>
                                    <div className="modal fade" id="clear-logo-attachment" tabIndex="-1" role="dialog">
                                        <div className="modal-dialog" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h4 className="modal-title">Clear logo</h4>
                                                </div>
                                                <div className="modal-body">Are you sure you want to clear file "{logoAttachment?.filename}"?</div>
                                                <div className="modal-footer">
                                                    <button type="button" className="btn btn-falcon-default" data-dismiss="modal">Cancel</button>
                                                    <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={() => setLogoAttachment(null)}>Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-3 col-12">
                                        <p className="font-weight-semi-bold mb-3">Web Kiosk Enabled</p>
                                    </div>
                                    <div className="col-md-6 col-12 custom-control custom-switch">
                                        <input
                                            className="custom-control-input"
                                            type="checkbox"
                                            id="web-kiosk-enabled"
                                            checked={ webKioskEnabled }
                                            onChange={ () => setWebKioskEnabled(!webKioskEnabled) } />
                                        <label
                                            className="custom-control-label"
                                            htmlFor="web-kiosk-enabled"
                                        ></label>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-3 col-12">
                                        <p className="font-weight-semi-bold mb-3">Kiosk App Enabled</p>
                                    </div>
                                    <div className="col-md-6 col-12 custom-control custom-switch ">
                                        <input
                                            className="custom-control-input"
                                            type="checkbox"
                                            id="kiosk-app-enabled"
                                            checked={ kioskAppEnabled }
                                            onChange={ () => setKioskAppEnabled(!kioskAppEnabled) } />
                                        <label className="custom-control-label" htmlFor="kiosk-app-enabled"></label>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-3 col-12">
                                        <p className="font-weight-semi-bold mb-3">Time Spans<span className="req"></span></p>
                                    </div>
                                    <div className="col-md-2 col-12 pl-0">
                                        <KioskTimeConfig
                                            updateList={ newList => setTimeSpanRows(newList) }
                                            handleAddRow={ (value, mode, customLabel, startTimeDeltaMinutes, endOfDayDeltaMinutes, maximumTimeOfDay) => {
                                                const payloadValue = (mode === 3 || mode === 4) ? null : value;
                                                setTimeSpanRows(prevState => [...prevState, { type: parseInt(mode), duration: payloadValue, label: customLabel, startTimeDeltaMinutes, endOfDayDeltaMinutes, maximumTimeOfDay }])
                                            } }
                                            handleUpdateRow={ (id, value, mode, customLabel, startTimeDeltaMinutes, endOfDayDeltaMinutes, maximumTimeOfDay) => updateTimeSpanRow(id, value, mode, customLabel, startTimeDeltaMinutes, endOfDayDeltaMinutes, maximumTimeOfDay) }
                                            handleDeleteRow={ id => setTimeSpanRows(timeSpanRows.toSpliced(id, 1)) }
                                            data={ timeSpanRows }
                                            editMode={ true }
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-3 col-12">
                                        <p className="font-weight-semi-bold mb-3">Hide Expiry Date</p>
                                    </div>
                                    <div className="col-md-6 col-12 custom-control custom-switch ">
                                        <input
                                            className="custom-control-input"
                                            type="checkbox"
                                            id="hide-expiry-date"
                                            checked={ hideExpiryDate }
                                            onChange={ () => setHideExpiryDate(!hideExpiryDate) } />
                                        <label className="custom-control-label" htmlFor="hide-expiry-date"></label>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-3 col-12">
                                        <p className="font-weight-semi-bold mb-3">Show Blue Badge Number</p>
                                    </div>
                                    <div className="col-md-6 col-12 custom-control custom-switch ">
                                        <input
                                            className="custom-control-input"
                                            type="checkbox"
                                            id="show-blue-badge-number"
                                            checked={ showBlueBadgeNumber }
                                            onChange={ () => setShowBlueBadgeNumber(!showBlueBadgeNumber) } />
                                        <label className="custom-control-label" htmlFor="show-blue-badge-number"></label>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-3 col-12">
                                        <p className="font-weight-semi-bold mb-3">Add entries to whole Client</p>
                                    </div>
                                    <div className='col-md-6 col-12 custom-control custom-switch'>
                                        <input
                                            className="custom-control-input"
                                            type="checkbox"
                                            id="add-entries-to-client"
                                            checked={ addEntriesToClient }
                                            onChange={ () => setAddEntriesToClient(!addEntriesToClient) } />
                                        <label className="custom-control-label" htmlFor="add-entries-to-client"></label>
                                    </div>
                                </div>
                                <div className="row mt-3 mb-1">
                                    <div className="col-md-3 col-12 ">
                                        <p className="font-weight-semi-bold mb-1">Maximum Stay</p>
                                    </div>
                                    <div className="col-md-6 col-12 d-flex align-items-center px-0">
                                        <MinutesInputWithUnit
                                            numberOfMinutes={ maxStayMinutes }
                                            handleChange={ setMaxStayMinutes }
                                        />
                                        <button type="button" className="btn btn-sm btn-falcon-default d-flex align-items-center m-0 ml-2" onClick={ () => setMaxStayMinutes(null) }>
                                            <i className="fas fa-undo mr-1"></i>
                                            Clear
                                        </button>
                                    </div>
                                </div>
                                
                                    <div className="row mb-3">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-1">No return within</p>
                                        </div>
                                        <div className="col-md-6 col-12 d-flex align-items-center px-0">
                                            <MinutesInputWithUnit
                                                numberOfMinutes={ noReturnWithinMinutes }
                                                handleChange={ setNoReturnWithinMinutes }
                                            />
                                            <button type="button" className="btn btn-sm btn-falcon-default d-flex align-items-center m-0 ml-2" onClick={ () => setNoReturnWithinMinutes(null) }>
                                                <i className="fas fa-undo mr-1"></i>
                                                Clear
                                            </button>
                                        </div>
                                    </div>

                                <div className="card-footer border-top ">
                                    <div className="row client-edit-buttons">
                                        <div className="col-6 col-sm-auto ml-auto pl-0">
                                            <div id="dashboard-actions">
                                                <Link to={ `/organisation/${ props.organisationId }/client/${ site.clientId }/site/${ props.match.params.siteId }` } className="btn btn-falcon-default btn-sm" type="button"><i className="fas fa-times"></i> Cancel</Link>
                                                <button
                                                    type="button"
                                                    disabled={timeSpanRows.length === 0 || stringHelpers.isNullOrEmpty(kioskName)}
                                                    className="btn btn-success btn-sm ml-2"
                                                    onClick={ () => handleSubmit() }>
                                                    <i className="fas fa-check"></i> Confirm
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}